module.exports = Jsw.skinUrl + "/icons/16/plesk/list-type-classic.png?3eb8621bc8257a9b5f9995433f509a57";